import FullWidthLayout from "@/layouts/FullWidthLayout";
import VTOForm from "@/components/Front/VTO/VTOForm";
import { FetchesData, Pageable } from "kinnect-mixins";

export default {
	name: "VtoEditPage",

	metaInfo: { title: "Update VTO" },

	mixins: [
		FetchesData,
		Pageable
	],

	render() {
		return <FullWidthLayout>
			<VTOForm></VTOForm>
		</FullWidthLayout>;
	}
};
